export class CookieAccessor {
    public static getCookie(name: string): string | null {
        const nameIndicator = name + '=';
        const cookiesCollection = document.cookie.split(';');
        for (let cookie of cookiesCollection) {
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1, cookie.length);
            }

            if (cookie.indexOf(nameIndicator) == 0) {
                return cookie.substring(nameIndicator.length, cookie.length);
            }
        }

        return null;
    }

    public static setCookie(name: string, value: string, expires: Date): void;
    public static setCookie(name: string, value: string, expiresSeconds: number): void;
    public static setCookie(name: string, value: string, expires: number | Date): void {
        let expirationDate: Date;
        if (expires instanceof Date) {
            expirationDate = expires;
        } else {
            expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + expires * 1000);
        }

        document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}`;
    }

    public static deleteCookie(name: string) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
}
